import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useParams } from 'react-router-dom';
import { updateCategory, CategoryDetails } from '../../actions/categoryAction';
import Axios from '../../axios/axios';


const EditCategory = () => {
  const dispatch = useDispatch();
  const { id } = useParams();

  const [name, setName] = useState('');
  const [title, setTitle] = useState('');
  const [priority, setPriority] = useState('');
  const [uploading, setUploading] = useState(false);
  const [photo1, setPhoto1] = useState('');



  const catDetails = useSelector((state) => state.catDetails);
  const { loading, error, category } = catDetails;

  useEffect(() => {
    dispatch(CategoryDetails(id));
  }, [dispatch]);

  useEffect(() => {
    setName(category?.categoryName);
    setTitle(category?.title);
    setPriority(category?.priority);
    setPhoto1(category?.photo)
  }, [category]);


  console.log(category.photo,"photo")

  const submitHandler = (e) => {
    e.preventDefault();

    updateCategory({
      name,
      title,
      priority,
      _id: id,
      photo: photo1,
    }).then((data) => {
      console.log(data);
      if (data.status === 200) {
        window.location.href = '/categories';
      }
    });

    //
  };

  const uploadFileHandler = async (e, val) => {
    console.log('uploading');
    const file = e.target.files[0];
    const formData = new FormData();
    formData.append('image', file);
    setUploading(true);

    try {
      const config = {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      };

      const { data } = await Axios.post('/api/upload', formData, config);

      if (val === 'photo1') {
        setPhoto1(data);
      }
      setUploading(false);
    } catch (error) {
      console.error(error);
      setUploading(false);
    }
  };

  return (
    <div className="row">
      <div class="col-12 grid-margin stretch-card">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title">Update Category</h4>
            <form class="forms-sample" onSubmit={submitHandler}>
              <div class="form-group">
                <label for="exampleInputName">Category Name</label>
                <input
                  type="text"
                  class="form-control"
                  onChange={(e) => setName(e.target.value)}
                  placeholder="name"
                  value={name}
                  required={true}
                />
              </div>

              <div class="form-group">
                <label for="exampleInputName">Title</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Title"
                  value={title}
                  onChange={(e) => setTitle(e.target.value)}
                />
              </div>
              <div class="form-group">
                <label for="exampleInputPriority4">Photo </label>

                <input
                  type="file"
                  className="form-control"
                  onChange={(e) => uploadFileHandler(e, 'photo1')}
                // required={true}
                />
              </div>
              <img
                src={
                  photo1 === ''
                    ? process.env.PUBLIC_URL + '/images/select_image.png'
                    : `${photo1}`
                }
                height="150"
                width="50%"

              />
              <div class="form-group">
                <label for="exampleInputPriority4">Priority</label>

                <input
                  type="number"
                  className="form-control"
                  placeholder="Priority"
                  value={priority}
                  onChange={(e) => setPriority(e.target.value)}
                />
              </div>

              <button type="submit" class="btn btn-primary mr-2">
                Submit
              </button>
              <Link to="/categories">
                <button class="btn btn-light">Cancel</button>
              </Link>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EditCategory;
